(function () {
  'use strict';

  function initReviewsShowcase(section) {
    var grid = section.querySelector('[data-rs-grid]');
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.children);
    if (!cards.length) return;

    if (!('IntersectionObserver' in window)) {
      return;
    }

    cards.forEach(function (card) {
      card.classList.add('rs-animate-ready');
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -40px 0px' }
    );

    cards.forEach(function (card, index) {
      card.style.transitionDelay = (index * 70) + 'ms';
      observer.observe(card);
    });
  }

  function initAll() {
    document.querySelectorAll('.reviews-showcase').forEach(initReviewsShowcase);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.reviews-showcase');
    if (section) initReviewsShowcase(section);
  });
})();
